import { DEMAND_DEFINITION_SUBSTEPS, type DemandDefinitionSubstep } from './types/DemandDefinitionSubstep';

export const isDemandDefinitionSubstep = (value: string): value is DemandDefinitionSubstep =>
    DEMAND_DEFINITION_SUBSTEPS.some((substep) => substep === value);
